import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import { observer, inject } from "mobx-react";

function Header(props) {
  const navigate = useNavigate();
  return (
    <div
      className={`${styles.header} ${props.className || ""} ${
        props.isWhite ? styles.isWhite : ""
      }`}
    >
      {props.left ? (
        props.left
      ) : (
        <span
          onClick={() => {
            navigate(-1);
          }}
        >
          <img
            src={require(`../../assets/imgs/arrows${
              props.isWhite ? "4" : ""
            }.png`)}
            alt=""
          />
        </span>
      )}
      <span>{props.title}</span>
      <div className={styles.right}>{props.right ? props.right : ""}</div>
    </div>
  );
}

export default inject("store")(observer(Header));
